// File: src/common/pagination/ModernPagination.jsx

import React from 'react';

const ModernPagination = ({
  totalPages,
  currentPage,
  onPageChange,
}) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) pages.push(i);
        pages.push('ellipsis');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('ellipsis');
        for (let i = totalPages - 2; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('ellipsis');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('ellipsis');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  const commonButtonClass =
    'w-8 h-8 flex items-center justify-center rounded-lg transition-colors text-sm border border-[#F1F1F1] font-lato not-italic font-semibold text-[13px] leading-[18px]';

  return (
    <div className="flex items-center gap-1 px-2 py-2">
      {/* First Page */}
      <button
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        aria-label="First Page"
        className={`${commonButtonClass} hover:bg-gray-100 text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        &laquo;
      </button>

      {/* Previous Page */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous Page"
        className={`${commonButtonClass} hover:bg-gray-100 text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        &lsaquo;
      </button>

      {/* Page Numbers */}
      {pageNumbers.map((page, index) => {
        if (page === 'ellipsis') {
          return (
            <span
              key={`ellipsis-${index}`}
              className="w-8 h-8 flex items-center justify-center text-gray-600 text-sm border border-[#F1F1F1] rounded-lg font-lato not-italic font-semibold text-[13px] leading-[18px] " 
            >
              ...
            </span>
          );
        }

        const isActive = currentPage === page;

        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`${commonButtonClass} ${
              isActive
                ? 'bg-[#FF8E1C] text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } font-medium`}
          >
            {page}
          </button>
        );
      })}

      {/* Next Page */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Next Page"
        className={`${commonButtonClass} hover:bg-gray-100 text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        &rsaquo;
      </button>

      {/* Last Page */}
      <button
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        aria-label="Last Page"
        className={`${commonButtonClass} hover:bg-gray-100 text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        &raquo;
      </button>
    </div>
  );
};

export default ModernPagination;
